import * as React from "react";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkNumberInput } from "uitk-react-input";
import { DriversAgeInputFieldProps } from "../typings";
import { observer } from "mobx-react";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "./l10n";

const DriverAgeInputField: React.FC<DriversAgeInputFieldProps> = observer(
  ({ carWizardState, colSpan, setInputsRefs }) => {
    const { formatText } = useLocalization();
    const { updateDriversAgeInput, driversAge, driversAgeInvalidKey } = carWizardState;
    const inputRef = React.createRef<HTMLInputElement>();
    const { driversAgePlaceholder } = locKeys;

    React.useEffect(() => {
      setInputsRefs(inputRef);
    });

    return (
      <UitkLayoutGridItem colSpan={colSpan}>
        <div>
          <UitkNumberInput
            hasVisibleLabel={false}
            label={formatText(driversAgePlaceholder)}
            onChange={updateDriversAgeInput}
            value={driversAge}
            placeholder={formatText(driversAgePlaceholder)}
            invalid={formatText(driversAgeInvalidKey)}
            domRef={inputRef}
          />
          <input type="hidden" name="age" value={driversAge} data-testid="drivers-age-input" />
        </div>
      </UitkLayoutGridItem>
    );
  }
);

export default DriverAgeInputField;
